import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { Badge } from '@vds/badges';
import { TextLink } from '@vds/buttons';
import { ModalBody, ModalFooter } from '@vds/modals';
import { Body, Title } from '@vds/typography';
import { TitleLockup } from '@vds/type-lockups';

import { VDSModal as Modal } from '../../common/Modal/VDSModal';
import { selectStateCache } from './@selectors';
import { usePlanExtrasHooks } from './@Redux/willowPlanExtras.hooks';

import { Margin } from '../../common/styles';
import { TilesContainer } from '../../common/Cart/Tiles.styles';
import { isMobile } from '../../common/Helpers';

const ExtrasModal = () => {
  const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const { planExtras } = usePlanExtrasHooks(stateCache);

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (val) => {
    if (!val) {
      setIsOpen(false);
    }
  };

  const getRedemptionSteps = (steps, index) => (
    <Margin top="10px" bottom="10px" left="10px">
      <Body size="large" primitive="span">
        <span dangerouslySetInnerHTML={{ __html: `${index + 1}. ${steps}` }} />
      </Body>
    </Margin>
  );

  const getOverlayContent = (overlayIndex) => {
    const steps = planExtras.choiceOlaySteps[overlayIndex];
    const filteredSteps = Object.values(steps);

    return (
      <Margin bottom="25px">
        <TitleLockup
          data={{
            title: {
              bold: false,
              size: 'titleMedium',
              children: planExtras.choiceOlayTtl[overlayIndex],
            },
            subtitle: {
              size: 'bodySmall',
              color: 'primary',
              children: planExtras.choiceOlayDesc[overlayIndex],
            },
          }}
        />

        <Margin top="10px">
          <Title size="titleSmall" primitive="span">
            {planExtras.choiceOlayStepsHead[overlayIndex]}
          </Title>
          <Margin bottom="10px" left="30px">
            <Body size="small" primitive="span">
              {planExtras.choiceOlaySteps[overlayIndex]}
            </Body>
          </Margin>

          {filteredSteps.length > 0 && filteredSteps.map((item, index) => getRedemptionSteps(item, index))}

          <Margin top="20px" bottom="10px">
            <Body size="small" color="#6F7171">
              <span dangerouslySetInnerHTML={{ __html: planExtras.choiceOlayFtr[overlayIndex] }} />
            </Body>
          </Margin>
        </Margin>
      </Margin>
    );
  };

  if (!planExtras || !planExtras.extrasCommonDesc) return null;

  return (
    <>
      <TilesContainer padding="24px" width="100%">
        {planExtras.extrasCallout && <Badge fillColor="black">{planExtras.extrasCallout}</Badge>}

        <Margin top="20px" bottom="10px">
          <Body size="large" primitive="p">
            {planExtras.extrasCommonDesc}
          </Body>
        </Margin>

        <TextLink
          type="standAlone"
          surface="light"
          onClick={() => setIsOpen(true)}
          data-testid="extrasModalOffers-test"
          data-track={`{"type": "link", "name": "Details|${planExtras.extrasCommonDesc}"}`}
        >
          Offer details
        </TextLink>
      </TilesContainer>

      {isOpen && (
        <div data-testid="plansPromoModal">
          <Modal
            // ariaLabel="Plans Promo Modal"
            opened={isOpen}
            onOpenedChange={handleOpenChange}
            id="redemptionModal"
            disableOutsideClick
            ariaLabel={`close|${planExtras.extrasCommonDesc}redemption steps modal`}
            dataTrack={`{"type": "link", "name": "close|${planExtras.extrasCommonDesc} redemption steps modal"}}`}
            openViewData={{
              name: `${planExtras.extrasCommonDesc} redemption steps modal`,
              selector: '#redemptionModal',
            }}
          >
            <ModalBody>{planExtras.planChoiceList.length > 0 && planExtras.planChoiceList.map((item) => getOverlayContent(item))}</ModalBody>
            <ModalFooter
              buttonData={{
                primary: {
                  width: isMobile() ? '100%' : '200px',
                  children: 'Close',
                  onClick: () => {
                    handleOpenChange();
                  },
                  'data-testid': 'close-plansPromoModal',
                  'data-track': `{"type": "link", "name": "close|${planExtras.extrasCommonDesc} redemption steps modal"}`,
                },
              }}
            />
          </Modal>
        </div>
      )}
    </>
  );
};

export default ExtrasModal;
